import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_bus" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_right" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_right" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_right" }, null, -1)
const _hoisted_7 = { class: "title" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_news" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_right" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_right" }, null, -1)
const _hoisted_11 = { class: "title" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_clear-sky" }, null, -1)
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_right" }, null, -1)
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_right" }, null, -1)
const _hoisted_17 = { class: "title" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_friends" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_right" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_right" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_right" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createVNode(_component_Accordion, { class: "menuAccordion" }, {
      default: _withCtx(() => [
        _createVNode(_component_AccordionTab, null, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createTextVNode(_toDisplayString(_ctx.$t("navigation_list.mobility")), 1)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _hoisted_4,
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.pushRoute('Parking')))
                }, _toDisplayString(_ctx.$t("navigation_list.parkings")), 1)
              ]),
              _createElementVNode("li", null, [
                _hoisted_5,
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pushRoute('FindPath')))
                }, _toDisplayString(_ctx.$t("navigation_list.transport")), 1)
              ]),
              _createElementVNode("li", null, [
                _hoisted_6,
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pushRoute('TrafficInfo')))
                }, _toDisplayString(_ctx.$t("navigation_list.traffic")), 1)
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, null, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createTextVNode(_toDisplayString(_ctx.$t("navigation_list.news_events")), 1)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _hoisted_9,
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.pushRoute('News')))
                }, _toDisplayString(_ctx.$t("navigation_list.news")), 1)
              ]),
              _createElementVNode("li", null, [
                _hoisted_10,
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.pushRoute('Events')))
                }, _toDisplayString(_ctx.$t("navigation_list.events")), 1)
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, null, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createTextVNode(_toDisplayString(_ctx.$t("navigation_list.environment")), 1)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("ul", null, [
              _createElementVNode("li", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.pushRoute('Weather')))
                }, _toDisplayString(_ctx.$t("navigation_list.weather")), 1)
              ]),
              _createElementVNode("li", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.pushRoute('AirQuality')))
                }, _toDisplayString(_ctx.$t("navigation_list.aqi")), 1)
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, null, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createTextVNode(_toDisplayString(_ctx.$t("navigation_list.about")), 1)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _hoisted_19,
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.pushRoute('AboutUs')))
                }, _toDisplayString(_ctx.$t("navigation_list.purpose")), 1)
              ]),
              _createElementVNode("li", null, [
                _hoisted_20,
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.pushRoute('TermsAndConditions')))
                }, _toDisplayString(_ctx.$t("navigation_list.terms")), 1)
              ]),
              _createElementVNode("li", null, [
                _hoisted_21,
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.pushRoute('PrivacyPolicy')))
                }, _toDisplayString(_ctx.$t("navigation_list.privacy")), 1)
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}